<div class="loader" *ngIf="loading">
  <mat-spinner [diameter]="150"></mat-spinner>
</div>
<div class="card">
  <app-header></app-header>
  <div class="container">
    <div class="background">
      <div data-test="imagem-cadastro" class="image"></div>
    </div>
    <form data-test="form-cadastro" [formGroup]="registerFormGroup" class="register-form">
      <fieldset data-test="div-form-cadastro" [disabled]="loading" class="fieldset">
        <h1 data-test="titulo-cadastro" class="register-message">{{'signUp.registerMessage' | translate}}</h1>

        <app-company-document [dataTest]="'campo-documento-cadastro'" [controlName]="'document'" [label]="'CPF/CNPJ'" data-test="campo-documento-cadastro" [showIcon]="true"></app-company-document>

        <mat-form-field data-test="container-email-cadastro" class="full-input-grid" appearance="outline">
          <mat-label data-test="rotulo-email-cadastro">{{ 'signUp.email' | translate }}</mat-label>
          <input data-test="campo-email-cadastro" type="email" matInput formControlName="email" placeholder="Ex: example@example.com"
            (blur)="isEmailValid()" autocomplete="email">
          <mat-error *ngIf="form['email'].invalid && !form['email'].hasError('emailExists')">
            {{message.errorMessage(form['email'])}}
          </mat-error>
          <mat-error *ngIf="form['email'].invalid && form['email'].hasError('emailExists')">
            {{message.emailInUse(form['email'].value)}}
          </mat-error>
          <mat-icon matPrefix>email</mat-icon>
        </mat-form-field>

        <mat-form-field data-test="container-nome-cadastro" class="full-input-grid" appearance="outline">
          <mat-label data-test="rotulo-nome-cadastro">{{ 'signUp.fullName' | translate }}</mat-label>
          <input data-test="campo-nome-cadastro" type="text" matInput formControlName="name">
          <mat-error *ngIf="form['name'].invalid">{{message.errorMessage(form['name'])}}</mat-error>
          <mat-icon matPrefix>assignment_ind</mat-icon>
        </mat-form-field>

        <mat-form-field data-test="container-senha-cadastro" class="full-input-grid senha" appearance="outline">
          <mat-label data-test="rotulo-senha-cadastro">{{ 'signUp.password' | translate }}</mat-label>
          <input data-test="campo-senha-cadastro" type="password" matInput formControlName="password" autocomplete="new-password" onPaste="return false" maxlength="30"
            (keypress)="justOneSpecialCharacter($event, 'password')">
          <mat-error *ngIf="form['password'].invalid && !form['password'].hasError('pattern')">
            {{message.errorMessage(form['password'])}}
          </mat-error>
          <mat-error *ngIf="form['password'].invalid && form['password'].hasError('pattern')">
            <ul>
              {{ 'signUp.passwordValidationHeader' | translate }}
              <li>{{ 'signUp.passwordValidationFirstItem' | translate }}</li>
              <li>{{ 'signUp.passwordValidationSecondItem' | translate }}</li>
              <li>{{ 'signUp.passwordValidationThridItem' | translate }}</li>
              <li>{{ 'signUp.passwordValidationFourthItem' | translate }}</li>
              <li>{{ 'signUp.passwordValidationFifthItem' | translate }}</li>
              <br />
              {{ 'signUp.passwordValidationFooter' | translate }}
            </ul>
          </mat-error>
          <mat-icon matPrefix>lock</mat-icon>
        </mat-form-field>

        <mat-form-field data-test="container-confirmar-senha-cadastro" class="full-input-grid" appearance="outline">
          <mat-label data-test="rotulo-confirmar-senha-cadastro">{{ 'signUp.confirmPassword' | translate }}</mat-label>
          <input data-test="campo-confirmar-senha-cadastro" type="password" matInput formControlName="repeatedPassword" autocomplete="new-password"
            onPaste="return false" maxlength="30">
          <mat-error *ngIf="form['repeatedPassword'].invalid && !form['repeatedPassword'].hasError('notSame')">
            {{message.errorMessage(form['repeatedPassword'])}}
          </mat-error>
          <mat-error *ngIf="form['repeatedPassword'].invalid && form['repeatedPassword'].hasError('notSame')">
            Senhas não conferem
          </mat-error>
          <mat-icon matPrefix>lock</mat-icon>
        </mat-form-field>

        <mat-form-field data-test="container-telefone-cadastro" class="full-input-grid" appearance="outline">
          <mat-label data-test="rotulo-telefone-cadastro">{{ 'signUp.phone' | translate }}</mat-label>
          <ngx-mat-intl-tel-input data-test="campo-telefone-cadastro" (countryChanged)="dialCodeChange($event.dialCode);" [preferredCountries]="['br']"
            formControlName="phone" [enablePlaceholder]="true" [enableSearch]="true" name="phone">
          </ngx-mat-intl-tel-input>
          <mat-error *ngIf="form['phone'].invalid">{{message.errorMessage(form['phone'])}}</mat-error>
          <mat-icon matPrefix>phone</mat-icon>
        </mat-form-field>

        <div class="full-input-grid referral-checkbox" *ngIf="!form['recommendationGuid'].value && !appConfig.isPartner">
          <mat-checkbox data-test="cbox-cod-indicacao" formControlName="hasReferralCode" color="primary">
            {{ 'signUp.hasReferralCode' | translate }}
          </mat-checkbox>
        </div>

        <mat-form-field *ngIf="form['hasReferralCode'].value"  class="full-input-grid" appearance="outline">
          <mat-label>{{ 'code.referralCodePlaceholder' | translate }}</mat-label>
          <input data-test="campo-cod-indicacao-cadastro" type="text" matInput formControlName="referralCode"
            [placeholder]="'code.referralCodePlaceholder' | translate"
            (input)="onReferralCodeInput($event)"
            maxlength="30" minlength="4">
          <mat-error *ngIf="form['referralCode'].invalid">{{message.errorMessage(form['referralCode'])}}</mat-error>
          <mat-icon matPrefix>card_giftcard</mat-icon>
        </mat-form-field>

        <a data-test="link-ja-tenho-conta" class="redirect-link" routerLink="/sign-in">{{ 'signUp.alreadyHaveAccount' | translate }}</a>
        <button data-test="btn-registrar" class="full-input-grid button" mat-raised-button color="primary" (click)="signup()">
          {{ 'signUp.registerButton' |translate }}
        </button>

      </fieldset>
    </form>
  </div>
</div>